import React, {useState, useEffect} from 'react';
import Autoembed from '../../lib/Autoembed';
import {Grid, Button, Grow} from '@mui/material';

const Iframe = ({handleIframe,iframe})=>{
 let iframeUrl = (iframe.type == 'tv'? Autoembed.generateEpisodeUrl(iframe.serieId, iframe.seasonNumber, iframe.episodeNumber):Autoembed.generateMovieUrl(iframe.movieId));
 return(
        <>
        {iframe.show == true?
            <Grow in>
            <Grid container paddingTop={2} paddingBottom={2} style={{position:"absolute", padding:"1rem", top:"4rem", backgroundColor:"rgb(17 17 17 / 96%)",justifyContent:"center"}}>
                <iframe src={iframeUrl} width="90%" height="600px" frameBorder="0" style={{borderRadius:"15px", marginLeft:'auto', marginRight:"auto"}} allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"/>
                <Button variant="contained" size="medium" color="error" style={{width:'80%', marginTop:"1%"}}  onClick={() => handleIframe({show:false})}>Fechar</Button>

            </Grid>
            </Grow>
            :
            <>
            </>
        }

        </>
    );
}
export default Iframe;